import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import media from '../../lib/styles/media';
import { useQuery } from '@apollo/react-hooks';
import {
  GetRecommendedPostResponse,
  GET_RECOMMENDED_POST,
  PartialPost,
} from '../../lib/graphql/post';
import PostCardGrid from '../../components/common/PostCardGrid';
import { themedPalette } from '../../lib/styles/themes';
import { detectAnyAdblocker } from 'just-detect-adblock';

function RelatedPost({
  postId,
  showAds,
  isContained = false,
}: {
  postId: string;
  showAds: boolean;
  isContained?: boolean;
}) {
  const [adBlocked, setAdBlocked] = useState(false);
  useEffect(() => {
    detectAnyAdblocker().then((detected: boolean) => {
      if (detected) {
        setAdBlocked(true);
      }
    });
  }, []);

  const { data } = useQuery<GetRecommendedPostResponse>(GET_RECOMMENDED_POST, {
    variables: {
      id: postId,
    },
  });

  const postWithAds = useMemo(() => {
    if (!data?.post) return null;
    if (!showAds || adBlocked) return data.post.recommended_posts;
    const cloned: (PartialPost | undefined)[] = [
      ...data.post.recommended_posts,
    ];
    // get random number between 0 and 3
    const randomIndex = () => Math.floor(Math.random() * 3);
    const firstAdIndex = randomIndex();

    cloned[firstAdIndex] = undefined;

    return cloned;
  }, [data, showAds, adBlocked]);

  // if (!postWithAds) return null;

  return (
    <>
      <Background isContained={isContained}>
        <Title>관심 있을 만한 포스트</Title>
        <Wrapper isContained={isContained}>
          <PostCardGrid posts={postWithAds || []} forPost />
        </Wrapper>
      </Background>
      <PullUp />
    </>
  );
}

const Title = styled.div`
  text-align: center;

  font-size: 2rem;
  font-weight: 400;
  color: ${themedPalette.text2};
  margin-bottom: 3.5rem;
  ${media.custom(1376)} {
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }
  ${media.medium} {
    font-size: 1.25rem;
  }
`;

const Background = styled.div<{ isContained: boolean }>`
  z-index: 5;
  position: relative;
  padding-top: 4rem;
  padding-bottom: 4rem;

  ${media.custom(1376)} {
    padding-top: 2rem;
    padding-bottom: 1rem;
  }
  margin-top: 4rem;
  background: ${(props) => (props.isContained ? 'transparent' : themedPalette.bg_page1)};
  box-shadow: ${(props) => (props.isContained ? 'none' : '0px -16px 16px rgb(0 0 0 / 4%)')};
`;
const Wrapper = styled.div<{ isContained: boolean }>`
  width: ${(props) => (props.isContained ? '768px' : '1376px')};
  margin: 0 auto;
  padding-bottom: 3rem;
  ${media.xlarge} {
    width: ${(props) => (props.isContained ? '768px' : '1024px')};
  }
  ${media.custom(1056)} {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const PullUp = styled.div`
  margin-bottom: -4rem;
`;

export default RelatedPost;
